<template>
    <div class="pro-body">
        <div class="pro-item" v-for="(item, index) in ordergoods">
            <van-row>
                <van-col span="24">
                    <h5><span>商品名称</span>{{item.goods_name}}<span v-if="item.parent_cart_id!=null" style="color: red">(赠)</span>
                    </h5>
                </van-col>
            </van-row>
            <van-row class="pro-item-by">
                <!-- <van-col span="12">
                     <p>使用价目表价格</p>
                 </van-col>
                 <van-col span="12" class="text-right">
                     <van-switch v-model="checked" @change="priceswitch"/>
                 </van-col>-->
            </van-row>
              <van-row v-if="item.spec&&item.spec!=''">
                  <p><span>规格</span>{{item.spec}}</p>
              </van-row>
            <van-row>
                <van-col span="8">
                    <p><span>订货数量</span>{{item.count}}</p>
                </van-col>
                <van-col span="8" class="text-center">
                    <p><span>赠送数量</span>{{item.give_count}}</p>
                </van-col>
                <van-col span="8" class="text-right">
                    <p><span>发运数量</span>{{item.shipment_count}}</p>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="12">
                    <!-- <p><span>商品单价</span>{{item.price}}</p> -->
                    <p v-if="item.discount">
                        <span>商品单价</span>{{item.price * item.discount}}
                    </p>
                    <p v-else-if="item.pay_discount">
                        <span>商品单价</span>{{item.price * item.pay_discount}}
                    </p>
                    <p v-else>
                        <span>商品单价</span>{{item.price}}
                    </p>
                </van-col>
                <van-col span="12" class="text-right">
                    <p><span>价目表单价</span>{{jmbjg[index]}}</p>
                </van-col>

                <!--<van-row v-if="item.parent_cart_id==null">-->
                    <!--<van-col span="24">-->
                        <!--<van-cell title="查看库存" value="" is-link @click="showKuCun(item)"/>-->
                    <!--</van-col>-->
                <!--</van-row>-->
                <!--<van-row v-else>-->
                    <!--<van-col span="12">-->
                        <!--<p><span>规则ID</span>{{item.GiftSurplusInfos[0].ruleId}}</p>-->
                    <!--</van-col>-->
                    <!--<van-col span="12" class="text-right">-->
                        <!--<p><span>总量</span>{{item.GiftSurplusInfos[0].giftCount}}</p>-->
                    <!--</van-col>-->
                    <!--<van-col span="12">-->
                        <!--<p><span>余量</span>{{item.GiftSurplusInfos[0].giftSurplusCount}}</p>-->
                    <!--</van-col>-->
                <!--</van-row>-->
            </van-row>
            <van-row class="pro-item-ft">
                <van-col span="18">
                   <!-- <p><span>出库编码</span>{{item.goods_out_code}}</p>
-->
                        <!--<van-field
                                v-model="goodcode[index]"
                                readonly
                                label="出库编码"
                                placeholder="请选择出库编码"
                                @focus="goodcodeShow(item,index)"
                        />
                        &lt;!&ndash; 出库编码 &ndash;&gt;
                        <van-popup v-model="goodcodeshow" position="bottom" :overlay="true">
                            <van-picker
                                    :columns="goodcodecolumns"
                                    show-toolbar
                                    @cancel="goodcodeCancel"
                                    @confirm="goodcodeConfirm"
                                    @change="goodcodeChange"
                            />
                        </van-popup>-->
                </van-col>
                <van-col span="6" class="text-right pro-edit">
                    <!-- <p>
                        <van-icon name="edit"/>
                        修改
                    </p> -->
                </van-col>
                <van-col span="24">
                    <p><span>商品小计</span>{{item.minSum}}</p>
                </van-col>
                <!--<van-col span="18">-->
                    <!--<p >-->
                        <!--<van-row>-->
                            <!--<van-field-->
                                    <!--v-model="addressPCS[index]"-->
                                    <!--readonly-->
                                    <!--label="供应商"-->
                                    <!--placeholder="请选择供应商"-->
                                    <!--@focus="showPop(item.goodsId,item.goods_code,index)"-->
                            <!--/>-->
                        <!--</van-row>-->
                    <!--</p>-->
                <!--</van-col>-->
                <!--<van-col span="18">-->
                    <!--<van-row v-if="data.isSumAudit">-->
                        <!--<van-field-->
                                <!--v-model="rule[index]"-->
                                <!--readonly-->
                                <!--label="同步规则"-->
                                <!--placeholder="请选择同步规则"-->
                                <!--@focus="showRule(item.goodsId,item.goods_code,index)"-->
                        <!--/>-->
                    <!--</van-row>-->
                    <!--&lt;!&ndash;<p v-if="!data.isSumAudit"><span>同步规则</span>{{item.erporjxc=='1'?'同步进销存':item.erporjxc=='同步进销存'?'同步进销存':item.erporjxc=='2'?'同步ERP':item.erporjxc=='同步ERP'?'同步ERP':''}}</p>&ndash;&gt;-->
                <!--</van-col>-->
                <van-col span="6" class="text-right pro-edit">
                    <!--<p>
                        <van-icon name="edit"/>
                        修改
                    </p>-->
                </van-col>
                <van-col span="24">
                    <p><span>促销活动</span>{{item.pname}}</p>
                </van-col>
            </van-row>
        </div>

        <van-popup v-model="popShow" position="bottom" :overlay="true">
            <van-picker
                    :columns="gys"
                    show-toolbar
                    value-key="name"
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
                    @change="onPickerChange"
            />
        </van-popup>

        <van-popup v-model="popRule" position="bottom" :overlay="true">
            <van-picker
                    :columns="columnsRule"
                    show-toolbar
                    value-key="name"
                    @cancel="onPickerCancel1"
                    @confirm="onPickerConfirm1"
                    @change="onPickerChange1"
            />
        </van-popup>

    </div>
</template>
<script>
    import {
        NavBar,
        Cell,
        CellGroup,
        Field,
        Button,
        Row,
        Col,
        Collapse,
        CollapseItem,
        Tabs,
        Tab,
        Switch,
        Picker,
        Popup,
        Dialog
    } from "vant";

    export default {
        name: "ApprovalDetail",
        components: {
            [Dialog.name]: Dialog,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [Switch.name]: Switch,
        },
        data() {
            return {
                activeNames: ["1"],
                checked: true,
                tabActive: 0,
                isOpen1: false,
                openText1: "展开",
                openIcon1: "arrow-down",
                orderInfo: {},
                ordergoods: [],
                listsup: [],
                curdata: JSON.parse(localStorage.getItem("curdata")),
                popShow: false,
                popRule: false,
                columns: {},
                columnsRule: [{'id': 1, 'name': '同步进销存'}, {'id': 2, 'name': '同步ERP'}],
                addressPCS: [],
                rule: [],
                actionStatus: localStorage.getItem("actionStatus"), //判断是待审批（可编辑）/已审批（不可编辑）
                goodId: 0,
                gys: [],
                supliname: [],
                data: {},
                jm: '',
                isjm: '',
                jmbjg: [],
                jmdata: {},
                gcode:'',
                gindex:0,
                spcode:[],
                gzcode:'',
                gzindex:0,
                szpcode:[],
                orderGoods:[],
                jmbGoods:'',
                goodcode: [],//出库编码部分
                goodcodecolumns: [],
                goodcodeshow: false,
                goodcodeindex: 0,
            };
        },
        mounted: function () {

        },
        props:{
            goodsList: {
                type: Array,
            default:()=>{return [];}
            },
            jamubiao:null
        },
        watch: {
            goodsList: {
                immediate: true,    // 这句重要
                handler (val)
                {
                    var arr = [];
                    for(var i = 0;i<val.length;i++){
                        arr.push(val[i]);
                    }
                    this.ordergoods = arr;
                    this.orderGoods=arr
                }
            },
            jamubiao:{
                immediate: true,    // 这句重要
                handler (val) {
                    let that=this
                    if(val){
                        let goodsId = []
                        let json = {}
                        let goodsCode = ''
                        let code = []
                        for (var i = 0; i < that.ordergoods.length; i++) {
                            json['goodsId'] = that.ordergoods[i].goods_code
                            json['unit_zhxs'] = that.ordergoods[i].unit_zhxs
                            goodsId[i] = json
                            goodsCode = goodsCode + that.ordergoods[i].goods_code
                            code[i] = that.ordergoods[i].goods_code
                        }
                        //erp信息-获取价目表价格
                        that.$api.post(that.jumuc.userCenter.getGoodsPriceByPriceListIdAndGoodsId,
                            {
                                "priceId": localStorage.getItem('jmbid'),
                                "goodsId": JSON.stringify(goodsId),
                                "goodsCode": goodsCode
                            },
                            successRes => {
                                let data = JSON.parse(successRes.data).data
                                let i = 0
                                that.ordergoods = []
                                that.jmdata = data
                                that.jmbGoods=''
                                let str=''
                                for (var key in data) {
                                    str=str+key+'-'+data[key]+','
                                    if (key == code[i]) {
                                        that.jmbjg[i] = data[key]
                                        i++
                                    }

                                        for (var k = 0; k < that.orderGoods.length; k++) {
                                            let good = that.orderGoods[k]
                                            if (k == that.ordergoods.length - 1) {
                                                that.ordergoods[k] = good
                                            }
                                            if (good.goods_code == key) {
                                                good.minSum = data[key] * good.shipment_count
                                                that.ordergoods[k] = good
                                            }
                                            that.jmbGoods=that.jmbGoods+ good.goods_code+'-'+data[key]+","
                                        }
                                }


                                var codes = ""

                                for (var j = 0; j < code.length; j++) {
                                    if (data[code[j]] == null || data[code[j]] == "") {
                                        codes += code + " ";
                                    }
                                }
                                if (codes.length > 1) {
                                    Dialog.alert({
                                        title: '',
                                        message: codes
                                    }).then(() => {
                                        // on close
                                    });
                                }else{
                                    that.$emit('jmbGoods', that.jmbGoods)
                                }
                            })
                    }
                }
            }
        },
        methods: {
            getjmb() {
                let that = this
                if (localStorage.getItem('jmbid') != '') {
                    if (that.jm != localStorage.getItem('jmbid')) {
                        that.jm = localStorage.getItem('jmbid')
                        let goodsId = []
                        let json = {}
                        let goodsCode = ''
                        let code = []
                        for (var i = 0; i < that.ordergoods.length; i++) {
                            json['goodsId'] = that.ordergoods[i].goods_code
                            json['unit_zhxs'] = that.ordergoods[i].unit_zhxs
                            goodsId[i] = json
                            goodsCode = goodsCode + that.ordergoods[i].goods_code
                            code[i] = that.ordergoods[i].goods_code
                        }
                        //erp信息-获取价目表价格
                        that.$api.post(that.jumuc.userCenter.getGoodsPriceByPriceListIdAndGoodsId,
                            {
                                "priceId": localStorage.getItem('jmbid'),
                                "goodsId": JSON.stringify(goodsId),
                                "goodsCode": goodsCode
                            },
                            successRes => {
                                let data = JSON.parse(successRes.data).data
                                let i = 0
                                that.ordergoods = []
                                that.jmdata = data
                                let str=''
                                for (var key in data) {
                                    str=str+key+'-'+data[key]+','
                                    if (key == code[i]) {
                                        that.jmbjg[i] = data[key]
                                        i++
                                    }
                                    if (localStorage.getItem('isjmbid') != '') {
                                        for (var k = 0; k < that.data.orderGoods.length; k++) {
                                            let good = that.data.orderGoods[k]
                                            if (k == that.ordergoods.length - 1) {
                                                that.ordergoods[k] = good
                                            }
                                            if (good.goods_code == key) {
                                                good.minSum = data[key] * good.shipment_count
                                                that.ordergoods[k] = good
                                            }

                                        }
                                    } else {
                                        that.ordergoods = that.data.orderGoods
                                    }
                                }
                                if(str!=''){
                                    str=str.substring(0,str.length-1)
                                    localStorage.setItem("goodjg", str);
                                }

                                var codes = ""

                                for (var j = 0; j < code.length; j++) {
                                    if (data[code[j]] == null || data[code[j]] == "") {
                                        codes += code + " ";
                                    }
                                }

                                if (codes.length > 1) {
                                    Dialog.alert({
                                        title: '',
                                        message: codes
                                    }).then(() => {
                                        // on close
                                    });
                                }


                            })
                    }
                }
                if (localStorage.getItem('isjmbid') != '') {
                    if (localStorage.getItem('isjmbid') == 'true') {
                        let data = that.jmdata
                        let sumPrice=0
                        for (var key in data) {
                            for (var k = 0; k < that.data.orderGoods.length; k++) {
                                let good = that.data.orderGoods[k]
                                if (k == that.ordergoods.length - 1) {
                                    that.ordergoods[k] = good
                                }
                                if (good.goods_code == key) {
                                    good.minSum = data[key] * good.shipment_count
                                    that.ordergoods[k] = good
                                }

                            }
                        }
                        //计算本次订单扣款金额
                        for(var n=0;n<that.ordergoods.length;n++){
                            sumPrice=sumPrice+that.ordergoods[n].minSum
                        }
                        localStorage.setItem("sumPrice",sumPrice)
                    } else {
                        that.ordergoods=[]
                        for (var k = 0; k < that.data.orderGoods.length; k++) {
                            let good = that.data.orderGoods[k]
                                good.minSum = good.price * good.shipment_count
                            that.ordergoods[k] = good
                        }
                    }
                }
            },
            showPop(id,goods_code,index) {
                let that = this
                that.goodId = id
                let i=0
                for (var key in that.columns) {
                    if (key == id) {
                        that.gys = that.columns[key]
                    }
                   /* if(i==0){
                        that.addressPCS[0]=that.gys[0].name
                        this.spcode[0]=this.gcode+'-'+that.gys[0].id
                    }*/
                }
                that.gcode=goods_code
                that.gindex=index
                that.popShow = true;
            },
            showRule(id,goods_code,index) {
                this.goodId = id
                this.gzcode=goods_code
                this.gzindex=index
                this.popRule = true;
            },
            onPickerCancel() {
                this.popShow = false;
            },
            onPickerConfirm(values) {
                this.addressPCS[this.gindex] = values.name;
                this.spcode[this.gindex]=this.gcode+'-'+values.id
                localStorage.setItem("goodgys", JSON.stringify(this.spcode));
                this.popShow = false;
            },
            onPickerChange(picker, values) {
                picker.setColumnValues(1, values.name)
            },
            onPickerCancel1() {
                this.popRule = false;
            },
            onPickerConfirm1(values) {
                this.rule[this.gzindex] = values.name;
                let json={}
                json['id']=values.id
                json['code']=this.gzcode
                this.szpcode[this.gindex]=json
                localStorage.setItem("goodRule", JSON.stringify(this.szpcode));
                this.popRule = false;
            },
            onPickerChange1(picker, values) {
                picker.setColumnValues(1, values.name)
            },
            back() {
                history.back();
            },
            showOpen1(i) {
                this.isOpen1 = !this.isOpen1;
                this.openText1 = this.isOpen1 ? '收起' : '展开';
                this.openIcon1 = this.isOpen1 ? 'arrow-up' : 'arrow-down';
            }, /*,priceswitch(checked){
                this.checked=checked
                localStorage.setItem("priceswitch", checked);
            }*/
            showKuCun(item) {
                this.$router.push({
                    path: '/stock/stocklist',
                    query: {
                        goodsId: item.goodsId,
                        goodsCode: item.goods_code,
                        unit_zhxs: item.unit_zhxs
                    }
                })
            }, goodcodeShow(item, index) {//选择业务编码部分
                let that = this
                that.goodcodeindex = index
                that.goodcodecolumns = item.goods_code.split(',')
                that.goodcodeshow = true
            }, goodcodeCancel() {
                let that = this
                that.goodcodeshow = false
            }, goodcodeConfirm(values) {
                let that = this
                that.goodcode[that.goodcodeindex] = values
                that.goodcodeshow = false
            }, goodcodeChange(picker, values) {
                picker.setColumnValues(1, values)
            }
        },
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;

    body {
        background: #f7f7ff;
    }

    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 80px;
        left: -10px;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }

    .jump-warphd {

        .van-icon {
            color: @bule-thame;
        }
        .appr-item {
            padding: 10px;
            margin-bottom: 10px;
            background-color: #fff;
            h5 {
                font-size: 16px;
                padding-bottom: 10px;
                i {
                    padding: 5px;
                    background-color: @bule-thame;
                    color: #fff;
                    border-radius: 100%;
                    margin-right: 5px;
                }
            }
            p {
                padding: 4px 0;
                font-size: 14px;
                &.item-r {
                    color: #ccc;
                    text-align: right;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
            }
            &-head {
                border-bottom: 1px #f7f7f7 solid;
                &-hd {
                    position: relative;
                }
            }
            &-foot {
                border-top: 1px #f7f7f7 solid;
                p {
                    color: #ccc
                }
            }
            .item-arrow {
                border-top: 1px solid #f7f7f7;
                text-align: center;
                color: @bule-thame;
            }
            .line {
                display: block;
                border-bottom: 1px solid #f7f7f7;
            }
        }

        .pro-body {
            padding: 10px;
            .pro-item {
                margin-bottom: 10px;
                background-color: #fff;
                padding: 10px;
                h5 {
                    font-size: 14px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #f7f7f7;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
                p {
                    font-size: 14px;
                    padding: 10px 0;
                }
                &-by {
                    padding: 10px 0 0;
                }
                &-ft {
                    background-color: #f7f7f7;
                    padding: 10px;
                    .van-cell {
                        background: none;
                        padding-left: 0;
                    }
                }
                .pro-edit {
                    color: @bule-thame;
                    text-decoration: underline;
                    i {
                        vertical-align: -2px;
                    }
                }
            }
        }
        .pay-by {
            padding: 10px;
            .pay-item {
                background-color: #fff;
                padding: 10px;
                position: relative;
                margin-bottom: 10px;
                p {
                    color: #ccc;
                    font-size: 12px;
                    padding: 5px 0;
                }
                &-ft {
                    padding-top: 10px;
                    p {
                        color: #333;
                    }
                }
                .pay-state {
                    text-align: right;
                    color: @bule-thame;
                    i {
                        display: inline-block;
                        padding: 5px;
                        border-radius: 100%;
                        background-color: @bule-thame;
                    }
                }
                &-rd {
                    position: absolute;
                    top: 0;
                    left: -5px;
                    width: 10px;
                    height: 100%;
                    background-color: @bule-thame;
                    border-radius: 10px 0 0 10px;
                }

                &.ok {
                    .pay-state {
                        color: #28a745;
                        i {
                            background-color: #28a745;
                        }
                    }
                    .pay-item-rd {
                        background-color: #28a745;
                    }
                }
                &.err {
                    .pay-state {
                        color: #ffc107;
                        i {
                            background-color: #ffc107;
                        }
                    }
                    .pay-item-rd {
                        background-color: #ffc107;
                    }
                }
            }
        }
        .pay-hd-item {
            margin-bottom: 10px;
            .pay-hd-line {
                border-bottom: 1px solid #f7f7f7;
                margin-bottom: 10px;
            }
            .van-field {
                border: 1px solid #f7f7f7;
            }
        }

        .van-cell:not(:last-child)::after {
            border: none;
        }

        .apply {
            .van-field {
                margin: 10px 0;
                border: 1px solid #f7f7f7;
            }
            .van-col--8 {
                padding: 0 10px;
            }
            button {
                font-size: 14px;
                height: 40px;
                line-height: 38px;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
            button.danger {
                background-color: #ffc107;
                border-color: #ffc107;
            }
        }

        .item-body-warp {
            height: 60px;
            overflow: hidden;
            position: relative;
        }
        .item-body-warp.open {
            height: auto;
        }
    }
</style>
